'use strict';
import angular from 'angular';

import AdGroupListHtmlUrl from './views/adgroup.list.html';
import _ from "lodash";

var app = angular.module('app.components', []);

app.component('adGroups', {
    bindings: {
        adGroups: '=',
        showActions: "=",
        modelValue : "=",
        clusterId: '=',
        clientId: '<',
        isEdit:"="
    },
    templateUrl: AdGroupListHtmlUrl,

    // The controller that handles our component logic
    controller: function($scope, $ioAlert, anchorSmoothScroll, $location, $timeout, ProductService, FormService, $stateParams, ModalService, $modal, $rootScope) {        var self = this;
        self.adGroupFormObj = {};
        self.adGroup = {};
        self.inMarketList =[];
        self.reMarketList =[];
        self.customAudienceList = [];
        self.combinedAudienceList = [];
        self.isMaximizeClicks = false;
        $scope.$watch('$ctrl.modelValue.target_cpa_enabled', function() {
                self.adGroupFormObj.ad_group_max_cpa = "";
        });

        $scope.$watch('$ctrl.modelValue.target_roas_enabled', function() {
                self.adGroupFormObj.ad_group_roas = "";
        });

        $scope.$watch("$ctrl.modelValue.bidding_strategy.bidding_method", function () {
            self.isMaximizeClicks = self.modelValue?.bidding_strategy?.bidding_method?.toLowerCase() === "maximize_clicks";
        });


        $scope.$watch('$ctrl.modelValue.campaign_advertising_channel_type', function () {
            const channelType = self.modelValue?.campaign_advertising_channel_type?.toLowerCase();
            if (channelType) {
                // Reset on each change
                self.showCustomAudience = false;
                if (channelType === 'search') {
                    self.adTypes = self.searchAdTypes;
                } else if (channelType === 'shopping') {
                    self.adTypes = self.shoppingAdTypes;
                } else if (channelType === 'display') {
                    self.adTypes = self.displayAdTypes;
                    self.showKeywords = false;
                    self.showCustomAudience = true;
                } else {
                    self.adTypes = [];
                }
            }
        });
        $rootScope.$on('target_impression_share_enabled', function (event, data) {
            self.adGroupFormObj.target_impression_share_enabled = data;
        });
            
        self.appStoreData = ["GOOGLE_PLAY","APPLE_ITUNES"];
        self.optionData =["YES","NO"]
        self.adTypeObj = { adType: "EXPANDED_DYNAMIC_SEARCH_AD", creativeImages:[] };
        self.keywordList = [
            { key: 'exact', val: 'Exact' },
            { key: 'phrase', val: 'Phrase' },
            { key: 'broad', val: 'Broad' },
            { key: 'negativeExact', val: 'Negative Exact' },
            { key: 'phraseExact', val: 'Phrase Exact' },
            { key: 'broadExact', val: 'Broad Exact' }
        ];
        self.keywordMatchTypes = ["Exact", "Phrase", "Broad"];
        self.keywords = [{
            "text": "",
            "matchType": "",
            "action":true,
            "isPositive": true
        }];
        self.adTypes = [];
        self.searchAdTypes = ["EXPANDED_DYNAMIC_SEARCH_AD", "CALL_ONLY_AD", "RESPONSIVE_SEARCH_AD"];
        self.displayAdTypes = ["IMAGE_AD"]
        self.shoppingAdTypes = ["SHOWCASE_AD", "PRODUCT_AD"];
        self.showAdGroupForm = false;
        self.showKeywords = true;
        self.showCustomAudience = false;
        self.showAdTypeForm = false;
        self.adGroupStatus = ["ENABLED", "PAUSED", "REMOVED"];
        self.groupSlides = [
            { "name": "adgroup" },
            { "name": "adtype" }
        ];
        self.isAdGroup = true;
        self.isAdType = false;
        self.trackingTemplateUrl = "";
        self.finalUrlSuffix = "";
        self.customParameters = [{
            "name": "",
            "value": ""
        }];

        //Show AdType by Sliding to the AdType View
        self.viewAdType = function(adgroup) {
            self.adGroup = adgroup;
            self.isAdGroup = false;
            self.showAdGroupForm = false;
            self.isAdType = true;
            //If there are no Adds create an Empty Array
            if (!self.adGroup.ads ) {
                self.adGroup.ads = [];
            };
            if (self.adGroup.ads && self.adGroup.ads.length == 0 && self.showActions) {
                self.addAdType();
            };
        };

        self.checkAudienceData = function (item) {
            if (item && self.modelValue.audience_targeting) {
                if ((self.modelValue.audience_targeting.inMarketList || []).length > 0 ||
                    (self.modelValue.audience_targeting.reMarketList || []).length > 0 ||
                    (self.modelValue.audience_targeting.customAudienceList || []).length > 0 ||
                    (self.modelValue.audience_targeting.combinedAudienceList || []).length > 0) {
                    self.adGroupFormObj.addAudience = false;
                    $ioAlert.show('', 'This campaign is already using audience targeting. Please remove the audience segments from campaign level before adding audience targeting to Ad group', 'error');
                }
            }
        } 

        //Show Ad Group Screen 
        self.backToAdGroup = function() {
            self.isAdGroup = true;
            self.isAdType = false;
            self.adGroup = {};
        }

        // Initialise Add group Form
        self.initAdGroup = function() {
            self.adGroupFormObj = {
                adGroupName: "",
                adGroupStatus: "",
                isAdGroupExt:false,
                callOutExt:{isCallOutExt:false},
                siteLinkExt:{isSitelinkExt:false},
                appExtension:{isAppExt:false},
                inMarketList: [],
                reMarketList: [],
                customAudienceList: [],
                combinedAudienceList: [],
                enableBidAmount:false
            };
            self.keywords = [{
                "text": "",
                "matchType": "",
                "action":true,
                "isPositive": true
            }];
            self.trackingTemplateUrl = "";
            self.finalUrlSuffix = "";
            self.customParameters = [{
                "name": "",
                "value": ""
            }];
        }

        self.onChangeExt = function(isAdExt){
            if(!isAdExt){
                self.adGroupFormObj.callOutExt = {isCallOutExt:false};
                self.adGroupFormObj.siteLinkExt = {isSitelinkExt:false};
                self.adGroupFormObj.appExtension= {isAppExt:false};
            }
        }

        //Show Add Group form 
        self.newAdGroup = function() {
            self.initAdGroup();
            self.showAdGroupForm = true;
            self.showAdTypeForm = false;
            self.isNewGroup = true;
        };

        //Hide Ad Group Form
        self.cancelAdGroup = function() {
            self.showAdGroupForm = false;
            self.initAdGroup();
        }

        // Edit Ad Group Form
        self.editAdGroup = function(adGroupFormObj, index) {
            self.showAdGroupForm = true;
            self.showAdTypeForm = false;
            self.adGroupFormObj = angular.copy(adGroupFormObj);
            self.groupIndex = index;
            self.keywords = angular.copy(self.adGroupFormObj.keywords);
            delete self.adGroupFormObj.keywords;
            self.customParameters = angular.copy(self.adGroupFormObj.customParameters);
            delete self.adGroupFormObj.customParameters;
            self.trackingTemplateUrl = angular.copy(self.adGroupFormObj.trackingTemplateUrl);
            delete self.adGroupFormObj.trackingTemplateUrl;
            self.finalUrlSuffix = angular.copy(self.adGroupFormObj.finalUrlSuffix);
            delete self.adGroupFormObj.finalUrlSuffix;
            self.isNewGroup = false;

            $location.hash('top-scroll');
            anchorSmoothScroll.scrollTo('top-scroll');
            $timeout(function() {
                $location.hash('');
            }, 500);
        }

        // Save AdGroup form
        self.saveAdGroup = function(form) {
            if (self.adGroupFormObj && self.adGroupFormObj.adGroupName != "" && self.adGroupFormObj.adGroupName != undefined && self.adGroupFormObj.adGroupStatus != "") {
                if (self.modelValue['target_cpa_enabled']) {
                    if (self.adGroupFormObj.ad_group_max_cpa && self.adGroupFormObj.ad_group_max_cpa != '') {
                        var isValidCpa = true;
                    } else {
                        var isValidCpa = false;
                    }
                } else {
                    var isValidCpa = true;
                }
                if (self.modelValue['target_roas_enabled']) {
                    if (self.adGroupFormObj.ad_group_roas && self.adGroupFormObj.ad_group_roas != '') {
                        var isValidRoas = true;
                    } else {
                        var isValidRoas = false;
                    }
                } else {
                    var isValidRoas = true;
                } 
                if(!self.modelValue['target_cpa_enabled'] && !self.modelValue['target_roas_enabled'] && !self.isMaximizeClicks){
                    if(self.adGroupFormObj.ad_group_cpc_bid != "" && self.adGroupFormObj.ad_group_cpc_bid != undefined){
                            var validDefaultBid = true;
                    } else if (self.adGroupFormObj.target_impression_share_enabled) {
                        var validDefaultBid = true;
                    } else {
                        var validDefaultBid = false;
                    }
                } else {
                    var validDefaultBid = true;
                }
                if(isValidRoas && isValidCpa && validDefaultBid){
                    self.adGroupFormObj.keywords = self.keywords;
                    self.adGroupFormObj.trackingTemplateUrl = self.trackingTemplateUrl;
                    self.adGroupFormObj.finalUrlSuffix = self.finalUrlSuffix;
                    self.adGroupFormObj.customParameters = self.customParameters;
                    if(self.adGroupFormObj.addAudience){
                        if(!self.adGroupFormObj['reMarketList']){
                            self.adGroupFormObj.reMarketList =[];
                        }
                        if(!self.adGroupFormObj['inMarketList']){
                            self.adGroupFormObj.inMarketList =[];
                        }
                        if (!self.adGroupFormObj['customAudienceList']) {
                            self.adGroupFormObj.customAudienceList = [];
                        }
                        if (!self.adGroupFormObj['combinedAudienceList']) {
                            self.adGroupFormObj.combinedAudienceList = [];
                        }
                    }
                    if(self.adGroupFormObj.addAudience && self.adGroupFormObj.reMarketList.length == 0 && self.adGroupFormObj.inMarketList.length == 0 && self.adGroupFormObj.customAudienceList.length === 0 && self.adGroupFormObj.combinedAudienceList.length === 0){
                       self.adGroupFormObj.addAudience = false;
                    }
                    if(!self.adGroupFormObj.addAudience){
                       self.adGroupFormObj.reMarketList =[];
                       self.adGroupFormObj.inMarketList =[];
                        self.adGroupFormObj.customAudienceList = [];
                        self.adGroupFormObj.combinedAudienceList = [];
                    }
                   if (self.isNewGroup === false) {
                       self.adGroups[self.groupIndex] = self.adGroupFormObj;
                   } else {
                       if (!self.adGroups) {
                           self.adGroups = [];
                       }
                       self.adGroups.push(self.adGroupFormObj);
                   }
                   self.showAdGroupForm = false;
                   self.initAdGroup();
                } else{
                    $ioAlert.show('', 'Please fill the required fields', 'error');
                }
            } else {
                $ioAlert.show('', 'Please fill the required fields', 'error');
            }
        }

        // Delete Ad Group Helper function
        self.delAdGroup = function(index) {
            self.showAdGroupForm = false;
            self.adGroups.splice(index, 1);
        }

        // Ad keyword new Helper function
        self.addKeyWord = function(element) {
            if(self.keywords){
                self.keywords.push({
                    "text": "",
                    "matchType": "",
                    "action":true,
                    "isPositive": true
                });
            } else{
                self.keywords =[];
                self.keywords.push({
                    "text": "",
                    "matchType": "",
                    "action":true,
                    "isPositive": true
                });
            }
        }

        // Delete Keyword Helper function
        self.delKeywordRow = function(index) {
            self.keywords.splice(index, 1);
        };

        self.addParameter =function(){
           if(self.customParameters.length < 8){
            self.customParameters.push({
                "name": "",
                "value": ""
            });
           }
        }

        self.delParameter = function(index) {
            self.customParameters.splice(index, 1);
        };

        /*
         * Update AdType Helper function to toggle Image Ad and expanded ad
         */
        self.updateAdType = function(type) {
            if (type === 'RESPONSIVE_SEARCH_AD' || type === 'IMAGE_AD') {
                self.adTypeObj = { adType: type, headlines: [], descriptions: [] };
                let initial_counter = 2;
                for (let i=0; i< initial_counter; i++) {
                    self.adTypeObj.headlines.push({});
                    self.adTypeObj.descriptions.push({});
                }
            } else {
                self.adTypeObj = { adType: type };
            }
        };

        self.getBulkKeywords = function() {
            let modalInstance = $modal.open(
                ModalService.returnModalType('getBulkKeywords', {
                    data: {
                        clientId: self.clientId
                    }
                })
            );
            modalInstance.result.then(function (keywords) {
                if (keywords && keywords.length > 0) {
                    if (!self.keywords) {
                        self.keywords = [];
                    }
                    _.each(keywords, function(item) {
                        self.keywords.push({
                            "text": item,
                            "matchType": "",
                            "action":true,
                            "isPositive": true
                        });
                    });
                }
            });
        };

        /*
         * Display Show AdType form
         */
        self.addAdType = function() {
            self.showAdTypeForm = true;
            self.isNewAd = true;
            self.adTypeObj = { adType: "EXPANDED_DYNAMIC_SEARCH_AD" };
        };

        self.addInputField = function (field_name){
            if (field_name === 'headline'  && self.adTypeObj.headlines.length < 13){
                self.adTypeObj.headlines.push({});
            }else if (field_name === 'description' && self.adTypeObj.descriptions.length < 4){
                self.adTypeObj.descriptions.push({});
            }else {
                // do nothing
            }
        }
        self.removeInputField = function (field,index){
            if (field === 'headline' && self.adTypeObj.headlines.length > 2) {
                self.adTypeObj.headlines.splice(index, 1);
            }else if (field === 'description' && self.adTypeObj.descriptions.length > 2) {
                self.adTypeObj.descriptions.splice(index, 1);
            }else {
                // do nothing
            }
        }

        self.showOrHideAddButton = function (input_field, index){
            if (input_field === 'headline' && self.adTypeObj.headlines.length - 1  === index){
                return true;
            }else if(input_field === 'description' && self.adTypeObj.descriptions.length - 1  === index){
                return true;
            }else{
                return false;
            }
        }

        self.isNewResponsiveSearchAd = function (){
            if (self.isNewAd && self.adGroup.ads.length === 0){ // new ad for create operation
                return true;
            }else if (self.isNewAd && self.isEdit){ // new ad for edit operation
                return false;
            }else if ((!self.isNewAd && !self.isEdit) || self.isNewAd){ // edit ad for create operation
                return true;
            }
            else{
                return false;
            }
        }

        self.isNewImageAd = function (){
            if (self.isNewAd && self.adGroup.ads.length === 0){ // new ad for create operation
                return true;
            }else if (self.isNewAd && self.isEdit){ // new ad for edit operation
                return false;
            }else if ((!self.isNewAd && !self.isEdit) || self.isNewAd){ // edit ad for create operation
                return true;
            }
            else{
                return false;
            }
        }

        self.getDisplayUrl = function (ad){
            if (ad !== undefined && ad.displayUrlSubDomain1 !== undefined && ad.displayUrlSubDomain2 !== undefined){
                return ad.displayUrlSubDomain1 + ' / ' + ad.displayUrlSubDomain2;
            }else if(ad.displayUrlSubDomain1 !== undefined){
                return ad.displayUrlSubDomain1;
            }else if (ad.displayUrlSubDomain2 !== undefined){
                return ad.displayUrlSubDomain2;
            }
            else{
                return "";
            }
        }

        self.getBrowserSpecificCss = function (action) {
            if (window.navigator.userAgent.indexOf('Mozzila') !== -1
                || window.navigator.userAgent.indexOf('Firefox') !== -1) {
                if (action === 'add headline') {
                    return self.isNewResponsiveSearchAd() === true ? '-278px' : '-200px';
                } else if (action === 'remove headline') {
                    return self.isNewResponsiveSearchAd() === true ? '-274px' : '-197px';
                } else if (action === 'add description') {
                    return self.isNewResponsiveSearchAd() === true ? '-248px' : '-172px';
                } else {
                    return self.isNewResponsiveSearchAd() === true ? '-184px' : '-108px';
                }
            } else if (window.navigator.userAgent.indexOf('Chrome') !== -1) {
                if (action === 'add headline') {
                    return self.isNewResponsiveSearchAd() === true ? '-274px' : '-200px';
                } else if (action === 'remove headline') {
                    return self.isNewResponsiveSearchAd() === true ? '-270px' : '-197px';
                } else if (action === 'add description') {
                    return self.isNewResponsiveSearchAd() === true ? '-245px' : '-170px';
                } else {
                    return self.isNewResponsiveSearchAd() === true ? '-182px' : '-107px';
                }
            }
        }

        /*
         * Display Edit Ad Type form
         */
        self.editAdType = function(ad, index) {
            self.showAdTypeForm = true;
            self.adTypeObj = angular.copy(ad);
            self.isNewAd = false;
            self.adIndex = index;
        }

        /*
         * Save/Edit Ad Type and update the AdGroup object
         */
        self.saveAdType = function(form) {
            if (form.$valid) {
                if (self.adGroup) {
                    if (!self.adGroup.ads) {
                        self.adGroup.ads = [];
                    }
                    if (self.isNewAd) {
                        self.adGroup.ads.push(self.adTypeObj);
                    } else {
                        self.adGroup.ads[self.adIndex] = self.adTypeObj;
                    }
                    self.showAdTypeForm = false;
                    self.adTypeObj = { adType: 'EXPANDED_DYNAMIC_SEARCH_AD' };
                }
            } else {

            }
        }

        /*
         * Delete Ad Type
         */
        self.delAdType = function(index) {
            self.showAdTypeForm = false;
            self.adGroup.ads.splice(index, 1);
        }

        /*
         * Cancel AdType form 
         */
        self.cancelAdType = function() {
            self.showAdTypeForm = false;
            self.adTypeObj = { adType: "EXPANDED_DYNAMIC_SEARCH_AD" };
        }

        var handleExpandedItems = function (inMarket) {
            inMarket.selectedChildrens = [];
            if (inMarket.isChecked) {
                inMarket.status = '';
                inMarket.isChecked = false;
                var selIndex = _.findIndex(self.adGroupFormObj.inMarketList, { id: inMarket.id });
                if (selIndex >= 0) {
                    self.adGroupFormObj.inMarketList.splice(selIndex, 1);
                }
                if (inMarket.childrenList && inMarket.childrenList.length > 0) {
                    _.each(inMarket.childrenList, function (children) {
                        children.status = '';
                        children.isChecked = false;
                        inMarket.selectedChildrens.push(children);
                    })
                }
            } else {
                inMarket.status = 'selected';
                inMarket.isChecked = true;
                if (inMarket.childrenList && inMarket.childrenList.length > 0) {
                    _.each(inMarket.childrenList, function (children) {
                        children.status = 'selected';
                        children.isChecked = true;
                        inMarket.selectedChildrens.push(children);
                    })
                }
                self.adGroupFormObj.inMarketList.push(inMarket);
            }
        }

        self.removeInMarkets = function (item, selectedInMarkets, marketsList) {
            if (_.has(item, 'parentId')) {
                var selIndex = selectedInMarkets.indexOf(item);
                if (selIndex >= 0) {
                    selectedInMarkets.splice(selIndex, 1);
                    item.status = '';
                    item.isChecked = false;
                }
            } else {
                var selIndex = selectedInMarkets.indexOf(item);
                if (selIndex >= 0) {
                    selectedInMarkets.splice(selIndex, 1);
                }
                var index = _.findIndex(marketsList, { id: item.id });
                if (index >= 0) {
                    marketsList[index].status = '';
                    marketsList[index].isChecked = false;
                    if (marketsList[index].childrenList && marketsList[index].childrenList.length > 0) {
                        _.each(marketsList[index].childrenList, function (children) {
                            children.status = '';
                            children.isChecked = false;
                        })
                    }
                }
            }
        }

        self.handleSelectReMarkets = function (reMarket, selectedReMarkets, marketsList) {
            if (reMarket.isChecked) {
                reMarket.status = '';
                reMarket.isChecked = false;
                var selIndex = self.adGroupFormObj.reMarketList.indexOf(reMarket);
                if (selIndex >= 0) {
                    self.adGroupFormObj.reMarketList.splice(selIndex, 1);
                } else {
                    if (self.adGroupFormObj.reMarketList && self.adGroupFormObj.reMarketList.length > 0) {
                        if (_.find(self.adGroupFormObj.reMarketList, { id: reMarket.id })) {
                            var index = _.findIndex(self.adGroupFormObj.reMarketList, { id: reMarket.id });
                            self.adGroupFormObj.reMarketList.splice(index, 1);
                        }
                    }
                }
            } else {
                reMarket.status = 'selected';
                reMarket.isChecked = true;
                self.adGroupFormObj.reMarketList.push(reMarket);
            }
        }

        self.handleSelectSubInMarkets = function (item, inMarket) {
            if (inMarket.isChecked) {
                inMarket.status = '';
                inMarket.isChecked = false;
                var selIndex = self.adGroupFormObj.inMarketList.indexOf(inMarket);
                var selIndex = _.findIndex(self.adGroupFormObj.inMarketList, { id: inMarket.id });
                if (selIndex >= 0) {
                    self.adGroupFormObj.inMarketList.splice(selIndex, 1);
                } else {
                    var parent = inMarket.parentId;
                    var selIndex = _.findIndex(self.adGroupFormObj.inMarketList, { id: parent });
                    var index = _.findIndex(self.inMarketList, { id: parent });
                    if (index >= 0) {
                        var childIndex = _.findIndex(self.inMarketList[index].selectedChildrens, { id: inMarket.id });
                        if (childIndex >= 0) {
                            if (selIndex >= 0) {
                                self.adGroupFormObj.inMarketList[selIndex].selectedChildrens.splice(childIndex, 1);
                                if (self.adGroupFormObj.inMarketList[selIndex].selectedChildrens && self.adGroupFormObj.inMarketList[selIndex].selectedChildrens.length == 0) {
                                    item.status = '';
                                    item.isChecked = false;
                                    self.adGroupFormObj.inMarketList.splice(selIndex, 1);
                                }
                            }
                        }
                    }
                }
            } else {
                inMarket.status = 'selected';
                inMarket.isChecked = true;
                if (item.isChecked) {
                    item.selectedChildrens.push(inMarket);
                } else {
                    item.selectedChildrens = [];
                    item.status = 'selected';
                    item.isChecked = true;
                    item.selectedChildrens.push(inMarket);
                    self.adGroupFormObj.inMarketList.push(item);
                }
            }
        }

        self.removeReMarkets = function (item, selectedReMarkets, marketsList) {
            if (_.has(item)) {
                var selIndex = selectedReMarkets.indexOf(item);
                if (selIndex >= 0) {
                    selectedReMarkets.splice(selIndex, 1);
                    item.status = '';
                    item.isChecked = false;
                }
            } else {
                var selIndex = selectedReMarkets.indexOf(item);
                if (selIndex >= 0) {
                    selectedReMarkets.splice(selIndex, 1);
                }
                var index = _.findIndex(marketsList, { id: item.id });
                if (index >= 0) {
                    marketsList[index].status = '';
                    marketsList[index].isChecked = false;
                }
            }
        }
        
        self.getInMarketContents = function () {
            ProductService.getDevicesByContentKey({ clusterId: self.clusterId, contentKey: 'google_ads_inmarket_category' }).then(function (success) {
                if (success && success.lookupContents && success.lookupContents.length > 0) {
                    _.each(success.lookupContents, function (content) {
                        var inMarkets = {};
                        inMarkets.id = content.id;
                        inMarkets.name = content.lookup_value;
                        inMarkets.status = "";
                        inMarkets.isChecked = false;
                        inMarkets.isExpand = false;
                        if (self.editMode) {
                            ProductService.getInMarketValuesByParent({ parent_id: content.id,order_id: $stateParams.orderId }).then(function (success) {
                                if (inMarkets.isChecked && success && success.values && success.values.length > 0) {
                                    inMarkets.isExpand = true;
                                } else {
                                    inMarkets.isExpand = false;
                                }
                            }, function (error) { });
                        }
                        inMarkets.childrenList = [];
                        inMarkets.selectedChildrens = [];
                        self.inMarketList.push(inMarkets);
                    });
                    processInMarketsData();
                }
            }, function (error) { });
        }

        var processInMarketsData = function () {
            if (self.editMode && self.adGroupFormObj) {
                var inMarketsList = [];
                var subInMarketsList = [];

                if ((self.adGroupFormObj.inMarketList && self.adGroupFormObj.inMarketList.length > 0)) {
                    inMarketsList = self.inMarketList;
                    subInMarketsList = self.adGroupFormObj.inMarketList;
                    processCategories(inMarketsList, subInMarketsList);
                }
            }
        }

        var processCategories = function (totalList, subList) {
            _.each(subList, function (subInMarket) {
                if (_.has(subInMarket, 'parentId')) {
                    var parentElement = _.find(totalList, { id: subInMarket.parentId });
                    if (parentElement) {
                        parentElement.selectedChildrens.push(subInMarket);
                    }
                    self.getSubInMarketList(parentElement);

                } else {
                    var parentElement = _.find(totalList, { id: subInMarket.id });
                    if (parentElement) {
                        parentElement.isChecked = true;
                        parentElement.status = 'selected';
                        parentElement.selectedChildrens = subInMarket.selectedChildrens;
                    }
                    self.getSubInMarketList(parentElement);
                }
            })
        }

        self.getSubInMarketList = function (category, isExpand) {
            ProductService.getInMarketValuesByParent({ parent_id: category.id,order_id: $stateParams.orderId }).then(function (success) {
                if (self.editMode && !category.isExpand && category.isChecked && success && success.values && success.values.length == 0) {
                    return;
                } else if (success && success.values && success.values.length > 0) {
                    category.childrenList = [];
                    _.each(success.values, function (content) {
                        var inMarket = {};
                        inMarket.id = content.id;
                        inMarket.name = content.value;
                        inMarket.status = "";
                        inMarket.isChecked = false;
                        inMarket.parentId = category.id;
                        category.childrenList.push(inMarket);
                    })
                    if (category.selectedChildrens && category.selectedChildrens.length > 0) {
                        _.each(category.selectedChildrens, function (children) {
                            _.each(category.childrenList, function (catChild) {
                                if (catChild.id == children.id) {
                                    catChild.status = 'selected';
                                    catChild.isChecked = true;
                                }
                            })
                        })
                    } else if (category.isChecked && category.childrenList && category.childrenList.length > 0) {
                        _.each(category.childrenList, function (children) {
                            children.isChecked = true;
                            children.status = "selected";
                            category.selectedChildrens.push(children);
                        })
                    }

                    category.isExpand = true;
                } else {
                    $ioAlert.show('Error!', 'No childrens are available for this ' + category.name + ' category', 'error');
                }
            }, function (error) { });
        }

        self.getReMarketList = function () {
            ProductService.getReMarketListValues({ order_id: $stateParams.orderId }).then(function (success) {
                if (success && success.values && success.values.length > 0) {
                    _.each(success.values, function (content) {
                        var reMarkets = {};
                        reMarkets.id = content.id;
                        reMarkets.name = content.name;
                        reMarkets.status = "";
                        reMarkets.isChecked = false;
                        self.reMarketList.push(reMarkets);
                    });
                    processReMarketsData();
                }
            }, function (error) { });
        }

        var processReMarketsData = function () {
            if (self.editMode && self.adGroupFormObj) {
                var reMarketsList = [];
                if ((self.adGroupFormObj.reMarketList && self.adGroupFormObj.reMarketList.length > 0)) {
                    reMarketsList = self.reMarketList;
                    processReMarketList(reMarketsList, self.adGroupFormObj.reMarketList);
                }
            }
        }

        self.handleSelectInMarkets = function (inMarket) {
            if (inMarket.isExpand) {
                handleExpandedItems(inMarket);
            } else {
                inMarket.selectedChildrens = [];
                if (inMarket.isChecked) {
                    inMarket.status = '';
                    inMarket.isChecked = false;
                    var selIndex = self.adGroupFormObj.inMarketList.indexOf(inMarket);
                    if (selIndex >= 0) {
                        self.adGroupFormObj.inMarketList.splice(selIndex, 1);
                    } else {
                        if (self.adGroupFormObj.inMarketList && self.adGroupFormObj.inMarketList.length > 0) {
                            if (_.find(self.adGroupFormObj.inMarketList, { id: inMarket.id })) {
                                var index = _.findIndex(self.adGroupFormObj.inMarketList, { id: inMarket.id });
                                self.adGroupFormObj.inMarketList.splice(index, 1);
                            }
                        }
                    }
                } else {
                    inMarket.status = 'selected';
                    inMarket.isChecked = true;
                    self.adGroupFormObj.inMarketList.push(inMarket);
                }
            }
        }

        // TOGGLE EXPAND
        self.toggleExpand = function(item) {
            item.isExpand = !item.isExpand;
        };

        // ------------------- CUSTOM AUDIENCE -------------------

        // Fetch Custom Audience values
        self.getCustomAudienceList = function () {
          ProductService.getCustomAudienceValues({ order_id: $stateParams.orderId }).then(function (success) {
            if (success && success.values && success.values.length > 0) {
              _.each(success.values, function (content) {
                var parsed = {};
                try {
                  parsed = JSON.parse(content.value); // parse the JSON string
                } catch (e) {
                  console.error("Invalid JSON in custom audience value:", content.value);
                }

                var customAud = {};
                customAud.id = parsed.id || content.id;
                customAud.name = parsed.name;
                customAud.status = "";
                customAud.isChecked = false;

                self.customAudienceList.push(customAud);
              });
              processCustomAudienceData();
              syncAudienceWithAdGroups('customAudienceList');
            }
          }, function (error) { });
        };

        // Process for edit mode (restore selected state)
        var processCustomAudienceData = function () {
            if (self.adGroupFormObj) {
                var audList = [];
                if ((self.adGroupFormObj.customAudienceList && self.adGroupFormObj.customAudienceList.length > 0)) {
                    audList = self.customAudienceList;
                    processCustomAudienceList(audList, self.adGroupFormObj.customAudienceList);
                }
            }
        };

        // Toggle select/deselect
        self.handleSelectCustomAudience = function (aud) {
            if (!self.adGroupFormObj.customAudienceList) {
                self.adGroupFormObj.customAudienceList = [];
            }

            if (aud.isChecked) {
                aud.status = '';
                aud.isChecked = false;
                _.remove(self.adGroupFormObj.customAudienceList, { id: aud.id });
            } else {
                aud.status = 'selected';
                aud.isChecked = true;
                self.adGroupFormObj.customAudienceList.push(aud);
            }
        };

        self.removeCustomAudience = function(aud) {
            _.remove(self.adGroupFormObj.customAudienceList, { id: aud.id });

            // reset UI state
            var index = _.findIndex(self.customAudienceList, { id: aud.id });
            if (index >= 0) {
              self.customAudienceList[index].isChecked = false;
              self.customAudienceList[index].status = '';
            }
        };

        // ------------------- COMBINED AUDIENCE -------------------

        self.getCombinedAudienceList = function () {
          ProductService.getCombinedAudienceValues({ order_id: $stateParams.orderId }).then(function (success) {
            if (success && success.values && success.values.length > 0) {
              _.each(success.values, function (content) {
                var parsed = {};
                try {
                  parsed = JSON.parse(content.value); // parse JSON string
                } catch (e) {
                  console.error("Invalid JSON in combined audience value:", content.value);
                }

                var combAud = {};
                combAud.id = parsed.id || content.id;
                combAud.name = parsed.name || "Unnamed Audience";
                combAud.status = "";
                combAud.isChecked = false;

                self.combinedAudienceList.push(combAud);
              });
              processCombinedAudienceData();
              syncAudienceWithAdGroups('combinedAudienceList');
            }
          }, function (error) { });
        };

        // Process for edit mode (restore selected state)
        var processCombinedAudienceData = function () {
            if (self.editMode && self.adGroupFormObj) {
                var audList = [];
                if ((self.adGroupFormObj.combinedAudienceList && self.adGroupFormObj.combinedAudienceList.length > 0)) {
                    audList = self.combinedAudienceList;
                    processCombinedAudienceList(audList, self.adGroupFormObj.combinedAudienceList);
                }
            }
        };

        // Toggle select/deselect
        self.handleSelectCombinedAudience = function (aud) {
            if (!self.adGroupFormObj.combinedAudienceList) {
                self.adGroupFormObj.combinedAudienceList = [];
            }

            if (aud.isChecked) {
                aud.status = '';
                aud.isChecked = false;
                _.remove(self.adGroupFormObj.combinedAudienceList, { id: aud.id });
            } else {
                aud.status = 'selected';
                aud.isChecked = true;
                self.adGroupFormObj.combinedAudienceList.push(aud);
            }
        };

        self.removeCombinedAudience = function(aud) {
          _.remove(self.adGroupFormObj.combinedAudienceList, { id: aud.id });

          // reset UI state
          var index = _.findIndex(self.combinedAudienceList, { id: aud.id });
          if (index >= 0) {
            self.combinedAudienceList[index].isChecked = false;
            self.combinedAudienceList[index].status = '';
          }
        };

        function processCustomAudienceList(fullList, selectedList) {
            _.each(fullList, function (item) {
                if (_.find(selectedList, { id: item.id })) {
                    item.isChecked = true;
                    item.status = 'selected';
                }
            });
        }

        function processCombinedAudienceList(fullList, selectedList) {
            _.each(fullList, function (item) {
                if (_.find(selectedList, { id: item.id })) {
                    item.isChecked = true;
                    item.status = 'selected';
                }
            });
        }

        // ------------------- SYNC FUNCTION -------------------
        function syncAudienceWithAdGroups(audienceKey) {
            if (!self[audienceKey]) return;

            var selectedList = [];

            // Include all selected audiences from adGroups
            if (self.adGroups && self.adGroups.length > 0) {
                self.adGroups.forEach(function (adGroup) {
                    if (adGroup[audienceKey] && adGroup[audienceKey].length > 0) {
                        selectedList = selectedList.concat(adGroup[audienceKey]);
                    }
                });
            }

            // Include adGroupFormObj if exists
            if (self.adGroupFormObj && self.adGroupFormObj[audienceKey]) {
                selectedList = selectedList.concat(self.adGroupFormObj[audienceKey]);
            }

            // Mark matching items as checked
            self[audienceKey].forEach(function (aud) {
                if (_.find(selectedList, { id: aud.id })) {
                    aud.isChecked = true;
                    aud.status = "selected";
                }
            });
        }

        self.openHelperTextPopup = function(){
            $modal.open(
                ModalService.returnModalType('showHelpertexts')
            ).result.then(function (res) {
                var test = res;
            });
        }

        /* 
         * Initialize the component hide the add/edit operations based on showActions boolean value
         */
        self.initComponent = function() {
            if (self.adGroups && self.adGroups.length != 0) {
                self.adGroups = JSON.parse(self.adGroups);
                self.initAdGroup();
                self.getInMarketContents();
                self.getReMarketList();
                self.getCustomAudienceList();
                self.getCombinedAudienceList();
            } else if (self.showActions) {
                self.adGroups = [];
                self.adGroupFormObj = {
                    inMarketList: [],
                    reMarketList: [],
                    customAudienceList: [],
                    combinedAudienceList: [],
                    enableBidAmount:false,
                    bidType:'bid_only'
                };
                self.editMode = true;
                self.enableViewMode = false;
                self.newAdGroup();
                self.getInMarketContents();
                self.getReMarketList();
                self.getCustomAudienceList();
                self.getCombinedAudienceList();
            }
        };

        self.initComponent();
    }
});